"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _analyticsContext = require("../analytics-context");

var _utils = require("../utils");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var withAnalytics = function withAnalytics(mapAnalyticsToProps) {
  return function (Component) {
    var displayName = (0, _utils.getDisplayName)(Component);

    var callListenerProvider = function callListenerProvider(props, context) {
      var callListener = (0, _react.useContext)(_analyticsContext.AnalyticsContext);
      var analyticsProps = {};

      if (!callListener) {
        throw Error("Could not find tracker in the context of " + "\"".concat(displayName, "\""));
      }

      if (typeof mapAnalyticsToProps === 'function') {
        analyticsProps = mapAnalyticsToProps(callListener);

        if (!analyticsProps || _typeof(analyticsProps) !== 'object') {
          throw Error("mapAnalyticsToProps should return an object, instead it returns " + "\"".concat(_typeof(analyticsProps), "\""));
        }
      } else {
        analyticsProps = {
          trackEvent: trackEvent
        };
      }

      var propsWithTracking = Object.assign({}, props, analyticsProps);
      return _react["default"].createElement(Component, propsWithTracking);
    };

    callListenerProvider.displayName = displayName; // callListenerProvider.contextTypes = {
    //     trackEvent: propTypes.func.isRequired
    // };

    return callListenerProvider;
  };
};

var _default = withAnalytics;
exports["default"] = _default;